/**************************************************************************************************/
/** @export Class @name Vector4                                                                  **/
/**************************************************************************************************/
export class Vector4
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private x: number
	private y: number
	private z: number
	private w: number

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor(x: number, y: number, z: number, w: number)
	{
		this.x = x
		this.y = y
		this.z = z
		this.w = w
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public getX() : number
	{
		return this.x
	}

	public getY() : number
	{
		return this.y
	}

	public getW() : number
	{
		return this.w
	}

	public getZ() : number
	{
		return this.z
	}

	public setX(x: number) : void
	{
		this.x = x
	}

	public setY(y: number) : void
	{
		this.y = y
	}

	public setW(w: number) : void
	{
		this.w = w
	}

	public setZ(z: number) : void
	{
		this.z = z
	}
}